import { api } from "./client";
import type { components } from "./contract";
import { unwrap } from "./errors";

type V2Generation = components["schemas"]["V2Generation"];

export async function getGeneration(
  generationID: string,
): Promise<V2Generation> {
  return unwrap(
    await api.GET("/v1/generations/{id}", {
      params: { path: { id: generationID } },
    }),
  );
}
